exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rdtPicker table{width:77% !important;}", ""]);

// exports
